import { z } from "zod";
export const userContextInputSchema = z.object({
    userId: z.string().min(1),
    key: z.string().min(1),
    value: z.string(),
});
export const userContextSchema = userContextInputSchema.extend({
    updatedAt: z.string().min(1),
});
//# sourceMappingURL=user-context.js.map